// extracted by mini-css-extract-plugin
export default {"partners":"Partners_partners__aakRH","logoPartners":"Partners_logoPartners__CU0zv"};